import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

// project imports
import { useAuth } from "../../../utils/auth";
import { useEffect } from "react";

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const OrganizationGuard = ({ children }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
    if (user && !user.organizacia) {
      navigate("/app/not-allowed");
    }
  }, [user, navigate]);

  return children;
};

OrganizationGuard.propTypes = {
  children: PropTypes.node,
};

export default OrganizationGuard;
